export default "__VITE_ASSET__CFinSU24__"